import * as z from 'zod';
/**
 * Builds a branded UUID schema.
 *
 * Branding makes identifier types mutually incompatible, so passing a `ChildId`
 * where a `DeviceId` is expected fails at compile time. This domain carries a
 * dozen identifier types, which makes that mistake realistic rather than
 * theoretical.
 */
const brandedId = () => z.uuid().brand();
export const familyIdSchema = brandedId();
export const userIdSchema = brandedId();
export const childIdSchema = brandedId();
export const deviceIdSchema = brandedId();
export const contentItemIdSchema = brandedId();
export const collectionIdSchema = brandedId();
export const viewingSessionIdSchema = brandedId();
export const remoteCommandIdSchema = brandedId();
export const importJobIdSchema = brandedId();
export const importSourceIdSchema = brandedId();
//# sourceMappingURL=id.js.map